
import { FC, useState } from 'react';

import {useIntl} from 'react-intl'

import { useLang } from '../../../../_metronic/i18n/Metronici18n';

import { ChatModel, ChatMessageModel } from '../../../models/chat';

import { ChatEditModal } from './ChatEditModal';
import { ConfirmModal } from '../../../components/ConfirmModal'
import {ChatShareModal} from './ChatShareOptions'

import { chatMessageAPI } from '../../../api'

interface Props {
  chat: ChatModel
  handleDeleteChat: () => void
}

const ChatOptions: FC<Props> = ({ chat, handleDeleteChat }) => {

  const intl = useIntl()
  const selectedLang = useLang()

  const [showEditModal, setShowEditModal] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [showShareModal, setShowShareModal] = useState(false)
  const [lastestChatMessage, setLastestChatMessage] = useState<ChatMessageModel | null>(null)
  
  const handleDelete = () => {
    setShowDeleteModal(false)
    handleDeleteChat()
  }

  const handleShare = async () => {
    const {data : {data}} = await chatMessageAPI.getAll(chat.id, false)
    setLastestChatMessage(data[data.length-1])
    setShowShareModal(true)
  }

  return <>
    <i 
      className="fa-solid fa-ellipsis fs-7 p-1" 
      data-kt-menu-trigger="click" 
      data-kt-menu-attach="parent" 
      data-kt-menu-placement={`${selectedLang == 'en' ? 'right' : 'left'}-start`}
    />
    <div 
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-2 fs-6 w-150px" 
      data-kt-menu="true"
    >
      <div className="menu-item px-3 my-0">
        <a 
          className={`menu-link px-3 py-2`} 
          onClick={(e) => {
            handleShare()
          }} 
        >
          <span className="menu-icon" data-kt-element="icon">
            <i className={`fa-solid fa-share-from-square fs-7 p-1`}></i>
          </span>
          <span className="menu-title">
          {intl.formatMessage({id: 'chat.share.button'})}
          </span>
        </a>
      </div>
      <div className="menu-item px-3 my-0">
        <a 
          className={`menu-link px-3 py-2`} 
          onClick={(e) => {
              setShowEditModal(true)
          }}
        >
          <span className="menu-icon" data-kt-element="icon">
            <i className="fa-solid fa-square-pen fs-7 p-1"></i>
          </span>
          <span className="menu-title">
            {intl.formatMessage({id: 'chat.edit_name.title'})}
          </span>
        </a>
      </div>
      <div className="menu-item px-3 my-0">
        <a 
          className={`menu-link px-3 py-2`} 
          onClick={(e) => {
            setShowDeleteModal(true)
          }} 
        >
          <span className="menu-icon" data-kt-element="icon">
            <i className="fa-solid fa-trash fs-7 p-1"></i>
          </span>
          <span className="menu-title">
            {intl.formatMessage({id: 'chat.delete'})}
          </span>
        </a>
      </div>
    </div>
    {lastestChatMessage && <ChatShareModal chatId={chat.id} show={showShareModal} lastestChatMessage={lastestChatMessage} handleClose={() => setShowShareModal(false)}/>}
    <ChatEditModal chat={chat} show={showEditModal} handleClose={() => setShowEditModal(false)} />
    <ConfirmModal show={showDeleteModal} handleConfirm={handleDelete} handleClose={() => setShowDeleteModal(false)}/>
  </>
}

export default ChatOptions